// extracted by mini-css-extract-plugin
export default {"overlay":"wz-z","bodyOpen":"xz-z","content":"yz-z","header":"zz-z","close":"Az-z","closeNoHeading":"Bz-z"};